import { CSSProperties, useCallback, useRef } from 'react'
import { useStyles } from '../styles/universal'

export const useScrollHighlight = (
    highlightStyles?: CSSProperties,
    duration = 2000
) => {
    const ref = useRef<HTMLDivElement>(null)
    const { classes } = useStyles()

    const scrollAndHighlight = useCallback(() => {
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth' })
            ref.current.classList.add(classes.highlighted)
            if (highlightStyles) {
                Object.assign(ref.current.style, highlightStyles)
            }
        }
        setTimeout(() => {
            ref.current?.classList.remove(classes.highlighted)
            if (highlightStyles && ref.current) {
                Object.keys(highlightStyles).forEach((key) => {
                    ref.current!.style.removeProperty(
                        key.replace(/[A-Z]/g, (m) => '-' + m.toLowerCase())
                    )
                })
            }
        }, duration)
    }, [classes.highlighted, highlightStyles, duration])

    return [ref, scrollAndHighlight] as const
}
